export default __webpack_public_path__ + "static/media/logo-with-name-footer.02d29e1d.svg";